import { jsonp } from '@ifeng/ui_base';

// apiUrl为webpack注入的全局变量
/* eslint-disable no-undef */
let apiBaseUrl = apiUrl;

/* eslint-enable no-undef */

if (typeof window === 'object' && /\.shank\.ifeng\.com/.test(window.location.hostname)) {
    apiBaseUrl = '/api';
}

/* 军事的调查 */
// 获取调查数据
export const getSurveyData = async id => {
    const { schemaCheck } = await import('./validate');

    let data = await jsonp('//sv.ifeng.com/index.php/survey/getdata', {
        data: {
            id,
        },
        jsonpCallback: 'getSurveyData',
        cache: false,
    });
    const requestUrl = `sv.ifeng.com/index.php/survey/getdata?id=${id}&callback=getSurveyData`;

    data = schemaCheck(data, 'surveyDataSchema', requestUrl);

    return data ? data : null;
};

// 提交调查数据
export const postSurveyData = async (param, id) => {
    return await jsonp(`//sv.ifeng.com/index.php/survey/postsurvey?${param}`, {
        data: {
            id,
        },
        jsonpCallback: 'postSurveyData',
        cache: false,
    });
};

/**
 *  创新首页
 */

// 获取热点新闻 三小图 hotNews 数据
const getHotNewsList = async () => {
    return await jsonp(`${apiBaseUrl}/innovation/index/hotNewsList/getHotNewsList`, {
        jsonpCallback: 'getHotNewsList',
        cache: false,
    });
};

// 获取幻灯 slider 数据
const getSliderList = async () => {
    let data = await jsonp(`${apiBaseUrl}/innovation/index/sliderList/getSliderList`, {
        jsonpCallback: 'getSliderList',
        cache: false,
    });

    const filterData = data.data && data.data.data && data.data.data.filter(item => item.thumbnailsCount !== 0);

    if (filterData && filterData.length >= 3) {
        data = filterData;
    } else {
        data = data.data.data;
    }

    return data;
};

// 获取首页信息流中穿插的第一个推荐位
const getIndexRecFirst = async () => {
    return await jsonp(`${apiBaseUrl}/innovation/index/recFirst/getIndexRecFirst`, {
        jsonpCallback: 'getIndexRecFirst',
        cache: false,
    });
};
// 获取首页信息流中穿插的第二个推荐位
const getIndexRecSec = async () => {
    return await jsonp(`${apiBaseUrl}/innovation/index/recSec/getIndexRecSec`, {
        jsonpCallback: 'getIndexRecSec',
        cache: false,
    });
};
// 获取首页信息流中穿插的第三个推荐位
const getIndexRecThr = async () => {
    return await jsonp(`${apiBaseUrl}/innovation/index/recThr/getIndexRecThr`, {
        jsonpCallback: 'getIndexRecThr',
        cache: false,
    });
};

// TYPE  delete  将该数据在数据源中删掉 【数据去重】

const newsListData = (recData, index, data, TYPE, translateFunction) => {
    const newDataFunc = () => {
        // 参数recData index TYPE  都是数组，支持批量去重后，批量插入

        const getItemData = (recDataItem, __type, __translateFunction) => {
            if (recDataItem.data.type === 'video') {
                __type += 'video';
            }
            const item = {
                ...recDataItem.data,
            };
            const res = {
                translateFunction: __translateFunction,
                ...item,
                type: __type,
                ...recDataItem.chipInfo,
                thumbnails: item.thumbnails
                    ? item.thumbnails
                    : {
                          image: [
                              {
                                  url: item.thumbnail,
                              },
                          ],
                      },
            };

            return res;
        };

        // 去重
        const deleteDupcateItemFromData = (recDataItem, type, translateFunction) => {
            // const item = getItemData(recDataItem, type, translateFunction);

            if (recDataItem.data.id) {
                data = data.filter(ITEM => ITEM.id !== recDataItem.data.id);
            }
        };

        // 插入
        const insertItemToData = (recDataItem, i, type, translateFunction) => {
            const item = getItemData(recDataItem, type, translateFunction);

            if (item) {
                data.splice(i, 0, item);
            }
        };

        // 遍历需要操作的数据
        recData.forEach((__eachData, __dataIndex) => {
            const type = TYPE[__dataIndex];
            const __translateFunction = translateFunction[__dataIndex];

            deleteDupcateItemFromData(__eachData, type, __translateFunction);
        });

        recData.forEach((__eachData, __dataIndex) => {
            const type = TYPE[__dataIndex];
            const __translateFunction = translateFunction[__dataIndex];

            insertItemToData(__eachData, index[__dataIndex], type, __translateFunction);
        });
    };

    switch (TYPE) {
        // 在data中 将recData数据去重
        case 'delete':
            recData.forEach(item => {
                if (item && item.id) {
                    data = data.filter(each => each.id !== item.id);
                }
            });

            break;
        default:
            // 在data中 将recData数据去重后 将recData 插入data中
            newDataFunc();
            break;
    }

    return data;
};

// 获取创新首页信息流
export const getIndexList = async (beginIndex, size, dealData) => {
    try {
        const defaultEachPageNum = 9;
        const begin = beginIndex || 0;

        const result = await jsonp(`${apiBaseUrl}/innovation/index/list/${begin}/${size}/getIndexListByPage`, {
            jsonpCallback: 'getIndexListByPage',
            cache: false,
        });

        let data = result.data;

        // 先去重
        const sliderList = dealData.slider;

        const sliderListData = sliderList && sliderList.slice(0, 3);

        data = newsListData(sliderListData, 12, data, 'delete');

        const hotNewsList = dealData.hotNews;
        // await getHotNewsList();

        const hotNewsListData = hotNewsList.slice(0, 3);

        data = newsListData(hotNewsListData, 12, data, 'delete');

        // 再插入信息流中的推荐位
        // 先将所有的去重，再做插入动作

        const recFirst = {
            data: dealData.recFirst,
            chipInfo: {
                chipId: '30002',
                chipTitle: '信息流通栏上推荐位',
            },
        };
        // await getIndexRecFirst();
        const recSec = {
            data: dealData.recSec,
            chipInfo: {
                chipId: '30003',
                chipTitle: '信息流通栏推荐位',
            },
        };
        // await getIndexRecSec();
        const recThr = {
            data: dealData.recThr,
            chipInfo: {
                chipId: '30004',
                chipTitle: '信息流通栏下推荐位',
            },
        };
        // await getIndexRecThr();

        const insertData = [recFirst, recSec, recThr];
        const insertPos = [4, 8, 12];
        const insertType = ['card16', 'card24', 'card16'];
        const translateFunction = ['formDataRecFirst', 'formDataRecSec', 'formDataRecThr'];

        data = newsListData(insertData, insertPos, data, insertType, translateFunction);

        data = data.map((item, i) => {
            return {
                ...item,
                index: i,
            };
        });

        return data.map(item => {
            const getCoverPic = () => {
                let res = '';

                if (item.thumbnails) {
                    if (typeof item.thumbnails === 'string') {
                        res = JSON.parse(item.thumbnails).image[0].url;
                    } else {
                        res = item.thumbnails.image[0].url;
                    }
                } else if (item.thumbnail && item.thumbnail !== '') {
                    res = item.thumbnail;
                }

                return res;
            };

            return {
                ...item,
                index: item.index,
                type: item.type,
                coverPic: getCoverPic(),
                link: item.url.indexOf('://') > -1 ? item.url : `//${item.url}`,
                title: item.title,
                card_content: item.summay || '',
                time: item.newsTime,
                source: item.source,
            };
        });
    } catch (e) {
        console.error(e);
    }
};

/**
 * 获取体育首页信息流初始数据
 * @param {string} dataType 获取数据类型：getSelectedPool/getDynamicFragment
 * @param {string} dataKey 获取数据的key值
 * @param {number} current 当前页数
 */
export const getSportsStreamInitData = async (dataType, dataKey, current) => {
    return await jsonp(
        `${apiBaseUrl}/sports/index/newStreamInitData_v2/${dataType}/${dataKey}/${current}/getSportsStreamInitData`,
        {
            jsonpCallback: 'getSportsStreamInitData',
            cache: 120,
        },
    );
};

// 获取文章评论数
// 新时代获取文章评论数
export const getCommentCount = async url => {
    return await jsonp('//comment.ifeng.com/get.php', {
        data: {
            job: 4,
            format: 'js',
            callback: 'getAllComment1',
            docurl: url.join('|'),
        },
        jsonCallback: 'getAllComment1',
        cache: false,
    });
};

// 在人间

// 点击更多，获取信息流
export const getLivingColumnData = async (start, end) => {
    const data = await jsonp(`${apiBaseUrl}/living/index/getLivingColumnData_v2/${start}/${end}/getLivingColumnData`, {
        jsonpCallback: 'getLivingColumnData',
    });

    return data;
};

// 地球青年图鉴栏目

// 点击更多，获取信息流
export const getGlobalyouthColumnData = async (currentLen, size = 10) => {
    const data = await jsonp(
        `${apiBaseUrl}/globalyouth/index/getGlobalyouthColumnData_v2/${currentLen}/${size}/getGlobalyouthColumnData`,
        {
            jsonpCallback: 'getGlobalyouthColumnData',
        },
    );

    return data;
};

/**
 * 获取custom数据
 * @param {string} dataKey 数据key
 */
export const getCustomData = async dataKey => {
    return await jsonp(`${apiBaseUrl}/sports/index/getCustomData/${dataKey}/getCustomData`, {
        jsonpCallback: 'getCustomData',
        cache: 120,
    });
};

/**
 * xinjinping 分页
 * @param {string} dataKey 数据key
 */
export const getXiNewsList = async ({ start, len }) => {
    return await jsonp(`${apiBaseUrl}/xijinping/index/getCustomNewsTfList/${start}/${len}/getCustomData`, {
        jsonpCallback: 'getCustomData',
        cache: 120,
    });
};

/**
 * xuanzhang2020 分页
 * @param {string} dataKey 数据key
 */
export const getXuanzhangNewsList = async ({ start, len }) => {
    return await jsonp(`${apiBaseUrl}/xuanzhan/index/getCustomNewsTfList/${start}/${len}/getCustomData`, {
        jsonpCallback: 'getCustomData',
        cache: 120,
    });
};

// so.ifeng.com
export const getSoFengData = async ({ __type, __k, __page }) => {
    return await jsonp(`${apiBaseUrl}/getSoFengData/${__type}/${__k}/${__page}/getSoFengDataCallback`, {
        jsonpCallback: 'getSoFengDataCallback',
    });
};
